module.exports = __webpack_public_path__ + "img/img19.0111a61d.png";